import { useProjectFinancialSummary } from "@/hooks/useProjectFinancialSummary";
import FinancialSummary from "@/components/financial/FinancialSummary";
import FinancialSummarySkeleton from "@/components/financial/FinancialSummarySkeleton";

interface SummarySectionProps {
  projectId: string;
}

export default function SummarySection({ projectId }: SummarySectionProps) {
  const { summary, loading } = useProjectFinancialSummary(projectId);

  if (loading) return <FinancialSummarySkeleton />;
  if (!summary) return null;

  return <FinancialSummary summary={summary} />;
}
